import React from "react";

const CustomTextArea = ({
    id,
    name,
    value,
    onChange,
    className = "",
    maxLength = 300,
    styles = {},
}) => {
    const defaultStyle = {
        border: "1px solid #727272",
        height: "55px",
        width: "95%",
    };

    return (
        <textarea
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            className="input-dash input-custom-space"
            maxLength={maxLength}
            style={{ ...defaultStyle, ...styles }}
        />
    );
};

export default CustomTextArea;
